<form [formGroup]="orgForm">
  <app-notification [errorMsg]="errorMsg"></app-notification>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xl-4">
              <div class="mb-3">
                <label for="name" class="form-label">Organization Name
                  @if (getFieldInfo('name'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control" readonly type="text" formControlName="name" id="name">
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-3">
                <label for="quickbookId" class="form-label">QuickBook Id
                  @if (getFieldInfo('quickbookId'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control" readonly type="text" formControlName="quickbookId" id="quickbookId">
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-3">
                <label class="form-label">Status
                  @if (getFieldInfo('status'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <select class="form-select"  formControlName="status">
                  <option>Select</option>
                  @for (status of statuses; track status) {
                    <option
                      [selected]="orgForm.value.status === status">{{status}}
                    </option>
                  }
                </select>
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-3">
                <label for="accountOwner" class="form-label">Account Owner
                  @if (getFieldInfo('accountOwner'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control"  type="text" [value]="orgForm.value.accountOwner"
                  formControlName="accountOwner" id="accountOwer">

              </div>
            </div>

            <div class="col-xl-4">
              <div class="mb-3">
                <label for="orgType" class="form-label">Organization Type<span
                style="color:var(--al-danger);">*</span>
                @if (getFieldInfo('organizationType'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <select class="form-select" id="orgType"  formControlName="organizationType">
                <option value="" selected>Select</option>
                @for (type of orgTypes; track type) {
                  <option
                    [selected]="orgForm.value.organizationType == type">
                  {{type}}</option>
                }
              </select>
              @if (submitted && organizationType && organizationType.invalid) {
                <span style="color:var(--al-danger)">Organization Type
                is required</span>
              }
            </div>
          </div>
          <div class="col-xl-4">
            <div class="mb-3">
              <label for="timeIncrement" class="form-label">Time Increment
                @if (getFieldInfo('timeIncrement'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <!-- <input class="form-control" type="number"  step="0.01"    formControlName="timeIncrement"> -->
              <select class="form-select" id="timeIncrement"  formControlName="timeIncrement">
                <option  selected>Select</option>
                @for (type of timeIncrementList; track type) {
                  <option [value]="type.value"
                    [selected]="orgForm.value.timeIncrement == type.value">
                  {{type.label}}</option>
                }
              </select>
              @if ( timeIncrement && timeIncrement.invalid) {
                <span style="color:var(--al-danger)">Time Increment is invalid</span>
              }
            </div>
          </div>
          <div class="col-xl-4">
            <div class="mb-3">
              <label class="form-label">Invoice Type<span
              style="color:var(--al-danger);">*</span>
              @if (getFieldInfo('invoiceType'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <select class="form-select"  formControlName="invoiceType">
              <option value="" selected>Select</option>
              @for (invoice of invoiceTypes; track invoice) {
                <option
                [selected]="orgForm.value.invoiceType == invoice">{{invoice}}</option>
              }
            </select>
            @if (submitted && invoiceType && invoiceType.invalid) {
              <span style="color:var(--al-danger)">Invoice Type
              is required</span>
            }
          </div>
        </div>
        <div class="col-xl-4">
          <div class="mb-3">
            <label class="form-label">Preferred Disbursement Type<span
            style="color:var(--al-danger);">*</span>
            @if (getFieldInfo('prefDisbursementType'); as info) {
              @if (info.showInformation === 'Yes' && info.informationText) {
                <info-tooltip [infoText]="info.informationText"></info-tooltip>
              }
            }
          </label>
          <select class="form-select"  formControlName="prefDisbursementType">
            <option value="" selected>Select</option>
            @for (type of prefDisbursementTypes; track type) {
              <option
              [selected]="orgForm.value.prefDisbursementType == type">{{type}}</option>
            }
          </select>
          @if (submitted && prefDisbursementType && prefDisbursementType.invalid) {
            <span style="color:var(--al-danger)">Preferred Disbursement Type
            is required</span>
          }
        </div>
      </div>

      <div class="col-xl-8">
        <div class="mb-3">
          <label for="notes">Notes
            @if (getFieldInfo('notes'); as info) {
              @if (info.showInformation === 'Yes' && info.informationText) {
                <info-tooltip [infoText]="info.informationText"></info-tooltip>
              }
            }
          </label>
          <textarea id="notes" class="form-control" rows="2"
          formControlName="notes" appSpellCheck></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-3">
        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" id="formCheck1"
            formControlName="isForceRequestedBy"
            (change)="onCheckboxChange($event)">
          <label class="form-check-label" for="formCheck1">
            Force Requested By
          </label>
        </div>
      </div>
      @if (orgForm.value.isForceRequestedBy) {
        <div class="col-xl-4">
          <label for="reqName" class="form-label">Requested By</label><span
        style="color:var(--al-danger);">*</span>
        <input class="form-control" formControlName="reqName" type="text" [(ngModel)]="reqName" id="reqName" appSpellCheck>
        @if (reqInvalid) {
          <span style="color:var(--al-danger)">Requested By
          is required</span>
        }
      </div>
    }
    @if (orgForm.value.isForceRequestedBy) {
      <div class="col-xl-5">
        <span appActionTooltip [pTooltip]="viewOnly ? 'Read-only view - open this organization in Edit mode to add requesters' : 'Add requester to the list'" [actionDisabled]="viewOnly" style="margin-top: 5%;">
          <button  class="btn btn-primary" [disabled]="viewOnly" (click)="addReq()" >Add</button>
        </span>
        <!-- <div class="btn btn-primary" readonly style="margin-top: 5%;margin-left: 7px;">
        <a class="btn btn-primary" (click)="addReq()">Add <i *ngIf="isLoading"
        style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i> </a>
      </div> -->
    </div>
  }
</div>
@if (orgForm.value.isForceRequestedBy) {
  <div class="row" style="margin:1%">
    <p-table [(value)]="orgForm.value.requestedPersons" [rowHover]="true" [scrollable]="true" scrollHeight="200px">
      <ng-template pTemplate="header">
        <tr>
          <th>Requester Name</th>
          <th style="width:6rem">Delete</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-req>
        <tr>
          <td>{{req}}</td>
          <td style="width:6rem">
            <div class="flex justify-content-between align-items-center">
              <span appActionTooltip [pTooltip]="viewOnly ? 'Read-only view - open this organization in Edit mode to remove requesters' : 'Remove this requester'" [actionDisabled]="viewOnly">
                <button  class="btn btn-warning btn-sm" [disabled]="viewOnly" (click)="deleteReq(req)" ><i class="mdi mdi-trash-can" width="44"
                height="44"></i></button>
              </span>
              <!-- <a class="btn btn-warning btn-sm" (click)="deleteReq(req)"
              role="button"><i class="mdi mdi-trash-can" width="44"
            height="44"></i></a> -->
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns && columns.length">
          No records found
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
}
<!-- <div class="row" *ngIf="viewOrg && !viewOnly">
<div class="col-xl-12">
  <div class="button-items" style="float: right;">
    <a class="btn btn-primary" (click)="saveOrg()"> Update <i *ngIf="btnLoading"
    style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i> </a>
  </div>
</div>
</div> -->
@if (!viewOnly) {
  <div class="row">
    <div class="col-xl-12">
      <div class="button-items" style="float: right;">
        <a class="btn btn-primary" (click)="saveOrg()" pTooltip="Save changes to organization" appActionTooltip> Update @if (btnLoading) {
          <i
          style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
        } </a>
        <a class="btn btn-secondary" (click)="closeDialog()" pTooltip="Cancel and close" appActionTooltip> Cancel </a>
      </div>
    </div>
  </div>
}
</div>
</div>
</div>
</div>
</form>
